import { RootState } from '@/store/index';
import { ActionContext, ActionTree } from 'vuex';
import { RESET_STORE } from '@/types/store.types';
import { AUTHENTICATION_RESET_STATE, AUTHENTICATION_ROOT } from '@/types/authentication.types';
import { AUTHORIZATION_RESET_STATE, AUTHORIZATION_ROOT } from '@/types/authorization.types';
import { FORM_RESET_STATE, FORM_ROOT } from '@/types/form.types';
import { CUSTOMER_RESET_STATE, CUSTOMER_ROOT } from '@/types/customer.types';
import { MANAGER_RESET_STATE, MANAGER_ROOT } from '@/types/managerForm.types';

export const actions: ActionTree<RootState, RootState> = {

  [RESET_STORE]: ({ commit }: ActionContext<RootState, RootState>) => {
    commit(AUTHENTICATION_ROOT + AUTHENTICATION_RESET_STATE);
    commit(AUTHORIZATION_ROOT + AUTHORIZATION_RESET_STATE);
    commit(FORM_ROOT + FORM_RESET_STATE);
    commit(CUSTOMER_ROOT + CUSTOMER_RESET_STATE);
    commit(MANAGER_ROOT + MANAGER_RESET_STATE);
  },

};
